/* eslint-disable @typescript-eslint/ban-types */
import { useTranslation } from 'react-i18next';
import Checkbox from '@ui-elements/Checkbox';
import styled from 'styled-components';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { IconButton } from '@mui/material';
import { QUESTION_CONFIG_TYPE, QUESTION_TYPE_ID } from '~/common/constants';

const ComponentControlBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

type Props = {
  questionIdx?: number;
  questionType: number;
  handleDuplicateQuestion: Function;
  handleDeleteQuestion: Function;
  handleRequiredChange?: Function;
  isRequired?: boolean;
  isRandom?: boolean;
  isGotoRequired?: boolean;
  itemIdx: number;
  isGotoAnswerEnabled?: boolean;
};

const ComponentControl: React.FC<Props> = ({
  questionIdx,
  questionType,
  isRequired,
  isRandom,
  isGotoRequired,
  handleRequiredChange,
  handleDuplicateQuestion,
  handleDeleteQuestion,
  itemIdx,
  isGotoAnswerEnabled = false,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ComponentControlBox>
      {handleRequiredChange && ![QUESTION_TYPE_ID.TEXT.valueOf()].includes(questionType) && (
        <Checkbox
          label={t('registration.originalForm.manual.componentControl.required')}
          name="required"
          checked={isRequired || false}
          handleChange={(event) => {
            event.stopPropagation();
            handleRequiredChange(QUESTION_CONFIG_TYPE.REQUIRED);
          }}
          dataTestId={`${itemIdx}-answer-required`}
          value="required"
          fontSize={24}
          labelFontSize="14px"
        />
      )}

      {handleRequiredChange &&
        ![
          QUESTION_TYPE_ID.SINGLE_ANSWER_PULLDOWN.valueOf(),
          QUESTION_TYPE_ID.FREE_ANSWER_SHORT.valueOf(),
          QUESTION_TYPE_ID.FREE_ANSWER_LONG.valueOf(),
          QUESTION_TYPE_ID.FREE_ANSWER_NUMERIC.valueOf(),
          QUESTION_TYPE_ID.TEXT.valueOf(),
        ].includes(questionType) && (
          <Checkbox
            label={t('registration.originalForm.manual.componentControl.random')}
            name="random"
            checked={isRandom || false}
            handleChange={(event) => {
              event.stopPropagation();
              handleRequiredChange(QUESTION_CONFIG_TYPE.RANDOM);
            }}
            dataTestId={`${itemIdx}-answer-random`}
            value="random"
            fontSize={24}
            labelFontSize="14px"
          />
        )}

      {handleRequiredChange &&
        [
          QUESTION_TYPE_ID.SINGLE_ANSWER.valueOf(),
          QUESTION_TYPE_ID.SINGLE_ANSWER_PULLDOWN.valueOf(),
        ].includes(questionType) && (
          <Checkbox
            label={t('registration.originalForm.manual.componentControl.gotoRequired')}
            name="gotoRequired"
            checked={isGotoRequired || false}
            handleChange={(event) => {
              event.stopPropagation();
              handleRequiredChange(QUESTION_CONFIG_TYPE.GOTO_REQUIRED);
            }}
            dataTestId={`${itemIdx}-answer-goto-required`}
            value="gotoRequired"
            fontSize={24}
            labelFontSize="14px"
            disabled={!isGotoAnswerEnabled}
          />
        )}

      <IconButton
        sx={{
          margin: '5px 10px 0px auto',
        }}
        onClick={(event) => {
          event.stopPropagation();
          handleDuplicateQuestion(itemIdx, questionIdx);
        }}
        aria-label={`${itemIdx}-duplicateQuestion`}
      >
        <ContentCopyRoundedIcon
          sx={{
            fontSize: '30px',
            color: '#425F77',
          }}
        />
      </IconButton>

      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          handleDeleteQuestion(itemIdx);
        }}
        sx={{ marginTop: '5px' }}
        aria-label={`${itemIdx}-deleteQuestion`}
      >
        <DeleteOutlinedIcon sx={{ fontSize: '30px', color: '#425F77' }} />
      </IconButton>
    </ComponentControlBox>
  );
};

export default ComponentControl;
